import axiosInstance, { microServices } from 'network/apis/index'
import { SuccessMessage } from 'network/messageTranslationHelpers/messages'
import { METHOD_TYPES } from 'utils/constants/index'

export const placeBetCrashGameService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'game/crash/place-bet', data, {
    server: microServices.USER_URL
    // successMessage: SuccessMessage.betPlacedSuccessfully
  })
}
export const escapeCrashBetService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'game/crash/player-escape', data, {
    server: microServices.USER_URL
  })
}

export const cancelCrashBetService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'game/crash/cancel-bet', data, {
    server: microServices.USER_URL,
    successMessage: SuccessMessage.betCancelledSuccessfully
  })
}
export const getAllRoundHistoryService = () => {
  return axiosInstance(METHOD_TYPES.get, '/game/crash/get-history', {
    server: microServices.USER_URL
  })
}

export const getMyBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/game/crash/my-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}

// not used
export const getPreviousRoundBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, 'game/crash/previous-round-placed-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}

export const getTopBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/game/crash/top-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}

// not used
export const verifyProvableFairCrashService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'game/crash/check-provable-fair', data, {
    server: microServices.USER_URL
  })
}

export const CrashCheckFairness = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'game/crash/check-fairness', data, {
    server: microServices.USER_URL
    // headers: { 'demo-game': isDemoGame }
  })
}
